import React from 'react'
import { createPortal } from 'react-dom'

const Portal: React.FC<{ children: React.ReactNode; rootNode?: HTMLElement | null }> = ({ children, rootNode }) => {
  if (!children) return null

  return createPortal(children, rootNode || document.body)
}

export default Portal
